
/**
 * @fileOverview WebTrends Corporate Events definition
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;
    
    define('views/UpdateLayoutChanges',['require','jquery','lib/Util','GlobalEventDispatcher','GlobalResizeListener'],function (require) {
        var $ = require('jquery');
        var util = require('lib/Util');
        var GlobalEventDispatcher = require('GlobalEventDispatcher');
        var GlobalResizeListener = require('GlobalResizeListener');

        $debug('Layout Change Handler Loaded... use ?debug=mmm_layouts for details');

        var UpdateLayoutChanges = function(){
            $debug('Layout Change Handler Start... ', 'mmm_layouts');
            /**
             * The global instance of an event dispatcher, used to subscribe to or publish events of global interest
             *
             * @default GlobalEventDispatcher.getEventDispatcher()
             * @property GlobalEventDispatcher
             * @type {jQuery}
             */
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();

            /**
             * The global instance of an event dispatcher, used to subscribe to or publish events of global interest
             *
             * @default GlobalResizeListener.getResizeListener()
             * @property GlobalResizeListener
             * @type {jQuery}
             */
            this.globalResizeListener = GlobalResizeListener.getResizeListener();

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @property isEnabled
             * @type bool
             */
            this.isEnabled = false;
            this.init();
        };

        /**
         * Initializes the Event Tracking
         * Runs a single setupHandlers call, followed by createChildren and layout
         * Exits early if it is already initialized
         *
         * @method init
         * @returns {UpdateLayoutChanges}
         */
        
        UpdateLayoutChanges.prototype.init = function() {

            this.setupHandlers()
                .createChildren()
                .resizeHandler()
                .enable();
            return this;
        };


        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * This creates event handlers and binds the scope
         * of the JS.
         *
         * @method setupHandlers
         * @returns {UpdateLayoutChanges}
         */
        UpdateLayoutChanges.prototype.setupHandlers = function() {
            // Bind event handlers scope here
            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.CONTEXT_CHANGE, this.resizeHandler.bind(this));
            return this;
        };

        /**
         * Create any child objects or references to DOM elements
         * Should only be run on initialization of the view
         *
         * @method createChildren
         * @returns {UpdateLayoutChanges}
         */
        UpdateLayoutChanges.prototype.createChildren = function() {
            return this;
        };

        /**
         * Remove any child objects or references to DOM elements
         *
         * @method removeChildren
         * @returns {UpdateLayoutChanges}
         */
        UpdateLayoutChanges.prototype.removeChildren = function() {

            return this;
        };

        /**
         * Enables the component
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {UpdateLayoutChanges}
         */
        UpdateLayoutChanges.prototype.enable = function() {
            if (this.isEnabled) {
                return this;
            }
            this.isEnabled = true;

            return this;
        };

        /**
         * Disables the component
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @method disable
         * @returns {UpdateLayoutChanges}
         */
        UpdateLayoutChanges.prototype.disable = function() {
            if (!this.isEnabled) {
                return this;
            }
            this.isEnabled = false;
            return this;
        };

        /**
         * Destroys the component
         * Tears down any events, handlers, elements
         * Should be called when the object should be left unused
         *
         * @method destroy
         * @returns {UpdateLayoutChanges}
         */
        UpdateLayoutChanges.prototype.destroy = function() {
            this.disable()
                .removeChildren();
            return this;
        };

        /**
         * This checks the current context from the event dispatcher. If it is
         * in small context, isSmallContext sets to true, any other context sets to
         * false.
         *
         * @method resizeHandler
         * @returns {ExpandContentView}
         * @private
         */
        UpdateLayoutChanges.prototype.resizeHandler = function() {
            
            var context = this.globalResizeListener.getCurrentContext();
            $debug('    Layout Handler... Layout is : ' + context, 'mmm_layouts');

            switch (true) {
            case context === 'luxuryContext':
                //luxury
                
                break;
            case context === 'largeContext':
                //desktop
                
                break;
            case context === 'mediumContext':
                //tablet
                
                break;
            case context === 'smallContext':
                //mobile

                break;
            default:
                //error flow
                
                break;
            }

            $debug('    firing maxWidthHeroFix()', 'mmm_layouts');
            //this.maxWidthHeroFix(context);

            return this;
        };

        UpdateLayoutChanges.prototype.maxWidthHeroFix = function(layout){
            $debug('    ...in Max Width Hero Fix', 'mmm_layouts');
            var heroSelector = $('.MMM--contentWrapper_hero'),
                tempAttribute = 'js-maxwidth',
                defaultWidth = '80%',
                origMaxWidth,
                jsMaxWidth;

            $debug('         found ' + heroSelector.length + ' heros on page', 'mmm_layouts');

            if (heroSelector.length !== 0){
                heroSelector.find('.MMM--heroCarouselButtonPositioner .MMM--isOnMobile .MMM--heroCarouselButtonContainer').each(function(i,e){
                    $debug('inside hero #' + i, 'mmm_layouts');
                    if (layout === 'smallContext'){
                        origMaxWidth = $(this).css('max-width');
                        if (origMaxWidth === 'none'){
                            origMaxWidth = defaultWidth;
                        }
                        $debug('    moving original max-width: ' + origMaxWidth + ' into attribute. Setting max-width to 100%;', 'mmm_layouts');
                        $(this).attr(tempAttribute, origMaxWidth);
                        $(this).css('max-width', '100%');
                    }
                    else {
                        if ($(this).attr(tempAttribute) !== undefined) {
                            //attribute has already been set - set back to match
                            jsMaxWidth = $(this).attr(tempAttribute);
                            $(this).css('max-width', jsMaxWidth);
                            $debug('    returning to original max-width of: ' + jsMaxWidth + '. Removed temporary attribute.', 'mmm_layouts');
                            $(this).removeAttr(tempAttribute);
                        }
                        else {
                            //attribute has not been set already - do nothing. 
                            $debug('    max-width has not been altered yet... doing nothing.', 'mmm_layouts');
                        }
                    }

                });
            }
        };

        var updateLayout = new UpdateLayoutChanges();
    }); //end define

}(MMMRequire));